import { supportPhoneDashed, supportPhoneLink } from '@/constants'
import { Icon } from '@/components'
import styles from './AreaPageHeader.module.scss'
import cn from 'classnames'

export const AreaPageHeader = ({ isIndexPage }: { isIndexPage?: boolean }) => {
  const urlLogo = isIndexPage ? '/images/full-logo-white.svg' : '/images/full-logo.svg'
  const iconName = isIndexPage ? 'headset-white' : 'phone-headset-icon'

  return (
    <header className={cn(styles.header, { [styles.header__indexPage]: isIndexPage })}>
      <img src={urlLogo} alt="Логотип HippoParking" className={styles.logo} />
      <a href={supportPhoneLink} className={styles.supportPhone}>
        <Icon name={iconName} />
        <span className={styles.supportPhone__number}>{supportPhoneDashed}</span>
      </a>
    </header>
  )
}
